import { createSelector } from '@ngrx/store';
import { userFeatureSelector, UserState } from '../reducer/user.reducer';

const userSelector = createSelector(userFeatureSelector, (state) => state);

const selectUser = createSelector(userSelector, (state: UserState) => state.user);
const getGequiredRolesCurrentPage = createSelector(userSelector, (state: UserState) => state.requiredRolesCurrentPage);

export const UserSelectors = { selectUser, getGequiredRolesCurrentPage };
